import React from 'react'

const ErrorPage = ({ errorCode, ErrorMessage }) => {
    return (
        <div>ErrorPage</div>
    )
}

export default ErrorPage